var _svg;
import React from 'react';
import { createSvgIcon } from '@mui/material/utils';

/**
 * TODO: these icons from im-theme were used in some of the Zenith components before
 * the icons were moved into ui-lib.
 *
 * The components that consume the icons below need to be updated to use Zenith icons.
 * Then this file can be deleted entirely.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ArrowRight = createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M5 12H19M19 12L12 5M19 12L12 19",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2"
}), 'arrow-right');
export var ArrowUp = createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M12 19V5M12 5L5 12M12 5L19 12",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2"
}), 'arrow-up');
export var Country = function Country() {
  return _svg || (_svg = /*#__PURE__*/_jsxs("svg", {
    fill: "none",
    height: "16",
    viewBox: "0 0 16 16",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg",
    "data-element": "svg",
    "data-component": "Country",
    "data-source-file": "im-theme-icons.tsx",
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_338_3907)",
      "data-element": "g",
      "data-source-file": "im-theme-icons.tsx",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M16 8C16 12.4183 12.4183 16 8 16C3.58175 16 0 12.4183 0 8C0 8.00187 8 0.00090625 8 0C12.4183 0 16 3.58175 16 8Z",
        fill: "#0052B4",
        "data-element": "path",
        "data-source-file": "im-theme-icons.tsx"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.97852 8.00045H7.99996C7.99996 7.99318 7.99996 7.98624 7.99996 7.979C7.99283 7.98617 7.98569 7.99331 7.97852 8.00045Z",
        fill: "#F0F0F0",
        "data-element": "path",
        "data-source-file": "im-theme-icons.tsx"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.99981 4.17464C7.99981 2.76698 7.99981 1.84458 7.99981 0.000732422H7.99847C3.58081 0.00145117 -0.000183105 3.58286 -0.000183105 8.0007H4.17372V5.65033L6.52409 8.0007H7.97844C7.98559 7.99358 7.99272 7.98645 7.99984 7.97929C7.99984 7.44033 7.99984 6.95942 7.99984 6.52504L5.64944 4.17464H7.99981Z",
        fill: "#F0F0F0",
        "data-element": "path",
        "data-source-file": "im-theme-icons.tsx"
      }), /*#__PURE__*/_jsx("path", {
        d: "M4.04739 1.0437C2.79617 1.75617 1.75599 2.79636 1.04352 4.04758V8.00023H3.13049V3.1307V3.13067H8.00005C8.00005 2.47245 8.00005 1.84539 8.00005 1.0437H4.04739Z",
        fill: "#D80027",
        "data-element": "path",
        "data-source-file": "im-theme-icons.tsx"
      }), /*#__PURE__*/_jsx("path", {
        d: "M8.00025 7.01658L5.15797 4.17433H4.17419C4.17419 4.1743 4.17419 4.17433 4.17419 4.17433L8.00022 8.00036H8.00025C8.00025 8.00036 8.00025 7.32208 8.00025 7.01658Z",
        fill: "#D80027",
        "data-element": "path",
        "data-source-file": "im-theme-icons.tsx"
      }), /*#__PURE__*/_jsx("path", {
        d: "M4.82504 9.39087L5.26411 10.3089L6.25557 10.0798L5.81157 10.9955L6.60889 11.6277L5.61617 11.8515L5.61895 12.8691L4.82504 12.2325L4.03117 12.8691L4.03395 11.8515L3.0412 11.6277L3.83854 10.9955L3.39448 10.0798L4.38601 10.3089L4.82504 9.39087Z",
        fill: "#F0F0F0",
        "data-element": "path",
        "data-source-file": "im-theme-icons.tsx"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.978 11.1301L12.1976 11.5892L12.6933 11.4746L12.4713 11.9324L12.87 12.2486L12.3736 12.3604L12.375 12.8693L11.978 12.5509L11.5811 12.8693L11.5825 12.3604L11.0861 12.2486L11.4848 11.9324L11.2628 11.4746L11.7585 11.5892L11.978 11.1301Z",
        fill: "#F0F0F0",
        "data-element": "path",
        "data-source-file": "im-theme-icons.tsx"
      }), /*#__PURE__*/_jsx("path", {
        d: "M9.93558 6.26099L10.1551 6.72005L10.6508 6.60542L10.4288 7.06327L10.8275 7.37942L10.3311 7.4913L10.3325 8.00011L9.93558 7.68177L9.53864 8.00011L9.53998 7.4913L9.04364 7.37942L9.4423 7.06327L9.2203 6.60542L9.71604 6.72005L9.93558 6.26099Z",
        fill: "#F0F0F0",
        "data-element": "path",
        "data-source-file": "im-theme-icons.tsx"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.978 3.47827L12.1976 3.93733L12.6933 3.82274L12.4713 4.28058L12.8699 4.59671L12.3736 4.70862L12.375 5.21743L11.978 4.89909L11.5811 5.21743L11.5825 4.70862L11.0861 4.59671L11.4847 4.28058L11.2628 3.82274L11.7585 3.93733L11.978 3.47827Z",
        fill: "#F0F0F0",
        "data-element": "path",
        "data-source-file": "im-theme-icons.tsx"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.7614 5.56519L13.9809 6.02425L14.4767 5.90962L14.2547 6.36747L14.6533 6.68362L14.157 6.79553L14.1583 7.30431L13.7614 6.986L13.3645 7.30431L13.3659 6.79553L12.8695 6.68362L13.2682 6.36747L13.0462 5.90962L13.5419 6.02425L13.7614 5.56519Z",
        fill: "#F0F0F0",
        "data-element": "path",
        "data-source-file": "im-theme-icons.tsx"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.4862 8.00024L12.6588 8.53168H13.2176L12.7655 8.86015L12.9383 9.39156L12.4862 9.06312L12.0341 9.39156L12.2068 8.86015L11.7547 8.53168H12.3135L12.4862 8.00024Z",
        fill: "#F0F0F0",
        "data-element": "path",
        "data-source-file": "im-theme-icons.tsx"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      "data-element": "defs",
      "data-source-file": "im-theme-icons.tsx",
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_338_3907",
        "data-element": "clipPath",
        "data-source-file": "im-theme-icons.tsx",
        children: /*#__PURE__*/_jsx("rect", {
          fill: "white",
          height: "16",
          width: "16",
          "data-element": "rect",
          "data-source-file": "im-theme-icons.tsx"
        })
      })
    })]
  }));
};
export var Plus = createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M12 5V19M5 12H19",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2"
}), 'plus');
export var XClose = createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M18 6L6 18M6 6L18 18",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2"
}), 'xclose');